<template>
  <!-- 登录页背景 -->
  <div class="login-page">
    <!-- 登录框 -->
    <div class="login-frame">
      <div class="qrcode-box">
        <div class="qrcode-title">扫码登录</div>
        <div>
          <a-image
              :height="200"
              :src="qrcodeurl"
              :width="200"
              class="qrcode-image"
          />
          <div v-if="qrcodestatus == 4" class="qrcode-status qrcode-expired">
            二维码失效,<a class="refresh-link" @click="loginMode('qrcode')">点击刷新</a>
          </div>
          <div v-else class="qrcode-status qrcode-valid">使用微信扫码登录</div>
        </div>
      </div>
      <div v-if="!isReset" class="login-form">
        <!-- 登录框标题 -->
        <div class="login-tab">
          <a-tabs v-model:activeKey="mode">
            <a-tab-pane key="account" tab="账号登录"></a-tab-pane>
            <a-tab-pane key="sms" tab="短信登录"></a-tab-pane>
          </a-tabs>
        </div>

        <!-- 登录 -->
        <div>
          <a-form ref="loginFormRef" :model="loginForm" :rules="rules">
            <a-form-item
                v-if="mode == 'sms' || mode == 'account'"
                name="account"
            >
              <a-input
                  v-model:value="loginForm.account"
                  placeholder="手机号"
                  size="large"
                  class="login-input"
              />
            </a-form-item>
            <a-form-item v-if="mode == 'account'" name="pwd">
              <a-input-password
                  v-model:value="loginForm.pwd"
                  placeholder="密码"
                  size="large"
                  class="login-input"
                  @pressEnter="loginsubmit"
              />
            </a-form-item>
            <a-form-item v-if="mode == 'sms'" name="code">
              <a-input
                  v-model:value="loginForm.code"
                  :autocomplete="false"
                  class="code-box"
                  placeholder="验证码"
                  size="large"
                  @pressEnter="loginsubmit"
              />
              <a-button
                  :disabled="disabled"
                  class="btn-info code-button"
                  size="large"
                  @click="handleGetCode"
              >
                {{ codeText }}{{ count ? count + "秒" : null }}
              </a-button>
            </a-form-item>
            <a-form-item v-if="mode == 'sms' || mode == 'account'">
              <a-button
                  :loading="loading"
                  block
                  class="btn-primary login-button"
                  shape="round"
                  size="large"
                  type="primary"
                  @click="loginsubmit"
              >
                登录
              </a-button>
            </a-form-item>
          </a-form>
          <div class="login-change">
            <div v-if="mode == 'account'" class="change-lef">
              <a-button type="link" @click="isReset = true">忘记密码</a-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 忘记密码 -->
      <div v-else class="login-form">
        <a-form ref="loginFormRef" :model="loginForm" :rules="rules">
          <a-form-item name="account">
            <a-input
                v-model:value="loginForm.account"
                placeholder="手机号"
                size="large"
                class="login-input"
            />
          </a-form-item>
          <a-form-item name="code">
            <a-input
                v-model:value="loginForm.code"
                :autocomplete="false"
                class="code-box"
                placeholder="验证码"
                size="large"
            />
            <a-button
                :disabled="disabled"
                class="btn-info code-button"
                size="large"
                @click="handleGetCode"
            >
              {{ codeText }}{{ count ? count + "秒" : null }}
            </a-button>
          </a-form-item>
          <a-form-item name="pwd">
            <a-input-password
                v-model:value="loginForm.pwd"
                placeholder="新密码"
                size="large"
                class="login-input"
            />
          </a-form-item>
          <a-form-item name="confirmpwd">
            <a-input-password
                v-model:value="loginForm.confirmpwd"
                placeholder="再次输入新密码"
                size="large"
                class="login-input"
            />
          </a-form-item>
          <a-form-item>
            <a-button
                :loading="resetLoading"
                block
                shape="round"
                size="large"
                type="primary"
                class="btn-primary"
                @click="resetSubmit"
            >
              确定
            </a-button>
          </a-form-item>
          <div class="login-change login-change-center">
            <div class="change-lef">
              <a-button type="link" @click="isReset = false">返回登录</a-button>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import {computed, defineComponent, onMounted, onUnmounted, reactive, toRefs,} from "vue";
import {message} from "ant-design-vue";
import {
  checkCode,
  companyBasics,
  getQrCode,
  loginAccount,
  loginSMS,
  smsCheckCode,
  smsSend,
  userChangepwd,
} from "@/api/api";
import router from "@/router/index";
import {verifyPhone} from "@/common/validator";
import landlord from "@/store/pms/landlord/index";

export default defineComponent({
  components: {},
  setup() {
    // 验证二次密码
    const verifyConfirPwd = async (rule, value) => {
      if (rule.required && !value) {
        return Promise.reject("请再次输入新密码");
      }
      if (login.loginForm.pwd !== value) {
        return Promise.reject("密码不一致");
      } else {
        return Promise.resolve();
      }
    };

    let login = reactive({
      loginForm: {
        account: "",
        pwd: "",
        confirmpwd: "",
        code: "",
      },
      timer: null,
      mode: "account",
      qrcode: "", //二维码的code
      qrcodeurl: "", //二维码的url
      qrcodestatus: 1, //二维码状态
      loginFormRef: "", //表单验证
      loading: false, //加载中
      disabled: computed(() => {
        if (login.count) {
          return true;
        }
        if (login.loginForm.account) {
          return false;
        } else {
          return true;
        }
      }),
      codeText: "获取验证码",
      count: null,

      //获取验证码
      handleGetCode() {
        login.loginFormRef
            .validate("account")
            .then(() => {
              smsSend({
                accept_phone: login.loginForm.account,
              }).then((res) => {
                message.success(res.msg);
                login.disabled = true;
                login.codeText = "已发送";
                login.count = 60;
                // 倒计时
                const timer = setInterval(() => {
                  if (login.count > 0 && login.count <= 60) {
                    login.count -= 1;
                  } else {
                    login.disabled = false;
                    login.codeText = "获取验证码";
                    login.count = null;
                    clearInterval(timer);
                  }
                }, 1000);
              });
            })
            .catch(() => {
              return false;
            });
      },

      //表单规则
      rules: {
        account: [
          {
            required: true,
            trigger: "blur",
            validator: verifyPhone,
          },
        ],
        pwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        confirmpwd: [
          {
            required: true,
            validator: verifyConfirPwd,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      //   登录
      loginsubmit() {
        if (login.loading) {
          return;
        }

        login.loginFormRef.validate().then(() => {
          if (login.mode == "sms") {
            login.loading = true;
            loginSMS({
              phone: login.loginForm.account,
              code: login.loginForm.code,
            })
                .then((res) => {
                  landlord.commit("saveToken", res.data.token);
                  login.saveUserInfo(res.data).then(() => {
                    login.loading = false;
                    getCompanyBasics();
                    landlord.dispatch("loadMenus").then(() => {
                      // 调试：打印获取到的路由数据
                      console.log('路由数据：', landlord.getters.getAddRouter);
                      // 确保有子路由
                      const addRouter = landlord.getters.getAddRouter;
                      if (addRouter && addRouter.children && addRouter.children.length > 0) {
                        const firstChildPath = addRouter.children[0].path;
                        // 构造完整的绝对路径
                        const fullPath = `/landlord/${firstChildPath}`;
                        console.log('跳转路径：', fullPath);
                        router.replace(fullPath);
                      } else {
                        console.error('没有获取到子路由数据');
                        router.replace('/landlord');
                      }
                    });
                  });
                })
                .catch(() => {
                  login.loading = false;
                });
          } else {
            login.loading = true;
            loginAccount({
              account: login.loginForm.account,
              pwd: login.loginForm.pwd,
            })
                .then((res) => {
                  landlord.commit("saveToken", res.data.token);
                  login.saveUserInfo(res.data).then(() => {
                    login.loading = false;
                    getCompanyBasics();
                    landlord.dispatch("loadMenus").then(() => {
                      // 调试：打印获取到的路由数据
                      console.log('路由数据：', landlord.getters.getAddRouter);
                      // 确保有子路由
                      const addRouter = landlord.getters.getAddRouter;
                      if (addRouter && addRouter.children && addRouter.children.length > 0) {
                        const firstChildPath = addRouter.children[0].path;
                        // 构造完整的绝对路径
                        const fullPath = `/landlord/${firstChildPath}`;
                        console.log('跳转路径：', fullPath);
                        router.replace(fullPath);
                      } else {
                        console.error('没有获取到子路由数据');
                        router.replace('/landlord');
                      }
                    });
                  });
                })
                .catch(() => {
                  login.loading = false;
                });
          }
        });
      },
      // getQrCodeinfo(){
      //   getQrCodeinfo();
      // },
      loginMode(str) {
        if (str == "qrcode") {
          getQrCodeinfo();
        } else {
          clearInterval(login.timer);
        }
      },

      async saveUserInfo(res) {
        sessionStorage.setItem("landlordInfo", JSON.stringify(res));
        return;
      },
    });

    // 获取房东基本信息
    function getCompanyBasics() {
      companyBasics().then((res) => {
        sessionStorage.setItem("companyInfo", JSON.stringify(res.data));
      });
    }

    //检查二维码
    function getQrCodeinfo() {
      getQrCode().then((res) => {
        login.qrcode = res.data.code;
        login.qrcodeurl = res.data.url;
        login.qrcodestatus = 1;
        getCheckCode();
      });
    }

    //检查二维码
    function getCheckCode() {
      login.timer = setInterval(() => {
        checkCode({
          code: login.qrcode,
        }).then((res) => {
          if (res.data.status == 2) {
                clearInterval(login.timer);
                landlord.commit("saveToken", res.data.loginInfo.token);
                login.saveUserInfo(res.data.loginInfo).then(() => {
                  login.loading = false;
                  getCompanyBasics();
                  landlord.dispatch("loadMenus").then(() => {
                    // 调试：打印获取到的路由数据
                    console.log('路由数据：', landlord.getters.getAddRouter);
                    // 确保有子路由
                    const addRouter = landlord.getters.getAddRouter;
                    if (addRouter && addRouter.children && addRouter.children.length > 0) {
                      const firstChildPath = addRouter.children[0].path;
                      // 构造完整的绝对路径
                      const fullPath = `/landlord/${firstChildPath}`;
                      console.log('跳转路径：', fullPath);
                      router.replace(fullPath);
                    } else {
                      console.error('没有获取到子路由数据');
                      router.replace('/landlord');
                    }
                  });
                });
            } else if (res.data.status == 4) {
            clearInterval(login.timer);
            login.qrcodestatus = 4;
          }
        });
        // 执行需要循环执行的逻辑
      }, 1000); // 每隔1秒执行一次
    }

    // 重置
    let reset = reactive({
      isReset: false,
      resetLoading: false,
      resetSubmit() {
        if (reset.resetLoading) {
          return;
        }
        login.loginFormRef.validate().then(() => {
          smsCheckCode({
            phone: login.loginForm.account,
            code: login.loginForm.code,
          }).then(() => {
            userChangepwd({
              pwd: login.loginForm.pwd,
              code: login.loginForm.code,
            }).then((res) => {
              message.success(res.msg);
              login.loginFormRef.resetFields();
              reset.isReset = false;
            });
          });
        });
      },
    });

    onUnmounted(() => {
      clearInterval(login.timer);
    });

    onMounted(() => {
      getQrCodeinfo();
      // setTimeout(() => {
      //   // message.success(`1.5秒----${navigator.platform}`);
      // }, 1500);
    });

    return {
      ...toRefs(login),
      ...toRefs(reset),
    };
  },
});
</script>

<style lang="scss" scoped>
.login-page {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  // 添加科技感强的背景效果
  background: linear-gradient(135deg, #0f0c29, #302b63, #24243e);
  overflow: hidden;

  // 添加动态背景效果
  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(0, 120, 255, 0.1) 0%, transparent 70%),
    conic-gradient(from 0deg at 50% 50%,
            rgba(0, 200, 255, 0.4) 0deg,
            rgba(100, 100, 255, 0.2) 120deg,
            rgba(0, 100, 255, 0.4) 240deg,
            rgba(0, 200, 255, 0.4) 360deg);
    animation: rotate 15s linear infinite;
    z-index: 0;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent 49%, rgba(0, 200, 255, 0.1) 50%, transparent 51%),
    linear-gradient(180deg, transparent 49%, rgba(0, 200, 255, 0.1) 50%, transparent 51%);
    background-size: 50px 50px;
    z-index: 1;
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .login-frame {
    // width: 400px;
    /* height: 350px;
    background-color: rbga(255, 255, 255, 0.7); */
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    margin: auto;
    border-radius: 20px;
    box-shadow: 0 0 35px 0 rgba(0, 100, 255, 0.2);
    padding: 30px 40px;
    display: flex;
    align-items: center;
    border: 1px solid rgba(100, 180, 255, 0.3);
    z-index: 2;
    position: relative;

    .qrcode-box {
      width: 300px;
      text-align: center;
      border-right: 2px solid rgba(100, 180, 255, 0.3);

      .qrcode-title {
        color: #ffffff;
        font-weight: bold;
        font-size: 16px;
        text-shadow: 0 0 8px rgba(100, 180, 255, 0.5);
      }
    }

    .login-title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 24%;
      font-size: 24px;
      /* border-bottom: 2px solid #dddddd; */
      color: #262c3a;
      font-weight: bold;
      /* letter-spacing: 2px; */
    }

    .login-form {
      margin-top: 10px;
      padding: 0 50px;
      width: 400px;
      // height: 350px;
      min-height: 350px;
      display: flex;
      flex-direction: column;
      // justify-content: center;

      .login-tab {
        margin-bottom: 20px;

        // 修改标签页样式以匹配科技感背景
        ::v-deep(.ant-tabs-tab) {
          color: rgba(255, 255, 255, 0.7);
        }

        ::v-deep(.ant-tabs-tab-active) {
          color: #fff;
          text-shadow: 0 0 8px rgba(100, 180, 255, 0.7);
        }

        ::v-deep(.ant-tabs-ink-bar) {
          background: linear-gradient(90deg, #00c6ff, #0072ff);
        }
      }

      .login-code {
        width: 33%;
        display: inline-block;
        height: 38px;
        float: right;
      }

      .login-tip {
        font-size: 18px;
        margin-bottom: 20px;
      }

      .login-input {
        margin: 20px 0;
      }

      .login-botton {
        margin: 20px 0;
      }

      .login-change {
        display: flex;
        justify-content: space-between;

        .change-lef {
        }

        .change-rig {
        }
      }

      .code-box {
        border-radius: 20px;
        width: 150px;
        margin-right: 20px;
        padding-left: 20px;
      }
    }
  }

  // 修改二维码文本颜色以提高可读性
  ::v-deep(.ant-image) {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    padding: 10px;
  }

  // 修改输入框样式
  ::v-deep(.ant-input-affix-wrapper),
  ::v-deep(.ant-input),
  ::v-deep(.ant-input-password) {
    background-color: rgba(255, 255, 255, 0.15) !important;
    border: 1px solid rgba(100, 180, 255, 0.3) !important;
    color: #fff !important;

    &::placeholder {
      color: rgba(255, 255, 255, 0.6) !important;
    }
  }

  // 单独设置验证码输入框为白色背景
  ::v-deep(.code-box) {
    ::v-deep(.ant-input) {
      background-color: #ffffff !important;
      border: 1px solid rgba(100, 180, 255, 0.3) !important;
      color: #333 !important;
      border-radius: 20px !important;

      &::placeholder {
        color: #999 !important;
      }
    }
  }

  ::v-deep(.ant-input-password-icon) {
    color: rgba(255, 255, 255, 0.6);
  }

  // 修改按钮样式
  ::v-deep(.btn-info) {
    //background-color: rgba(100, 180, 255, 0.2) !important;
    background-color: white;
    border: 1px solid rgba(100, 180, 255, 0.3) !important;
    color: #666666 !important;
    border-radius: 20px !important;
    box-shadow: 0 0 5px rgba(100, 180, 255, 0.1) !important;

    &:hover {
      box-shadow: 0 0 10px rgba(100, 180, 255, 0.3) !important;
    }
  }

  ::v-deep(.btn-primary) {
    background: linear-gradient(90deg, #00c6ff, #0072ff) !important;
    border: none !important;
    box-shadow: 0 0 15px rgba(0, 120, 255, 0.4) !important;
  }

  // 修改链接样式
  ::v-deep(.ant-btn-link) {
    color: rgba(100, 180, 255, 0.8) !important;

    &:hover {
      color: #00c6ff !important;
      text-shadow: 0 0 8px rgba(100, 180, 255, 0.7) !important;
    }
  }
}
</style>
